/**
 * Stabiele identiteiten voor pagina's en blokken.
 *
 * Bewust geen array-index als identiteit: selectie, undo/redo, slepen en de
 * opslag moeten allemaal naar hetzelfde blok blijven wijzen nadat er iets
 * boven is ingevoegd of verwijderd. De id die hier ontstaat is dezelfde id
 * die de backend opslaat en die de gerenderde website als React-key
 * gebruikt.
 */
function randomId(): string {
  const globalCrypto = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (globalCrypto && typeof globalCrypto.randomUUID === 'function') {
    return globalCrypto.randomUUID();
  }
  if (globalCrypto && typeof globalCrypto.getRandomValues === 'function') {
    const bytes = globalCrypto.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function createPageId(): string {
  return `page-${randomId()}`;
}

export function createBlockId(): string {
  return `block-${randomId()}`;
}
